import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ProgressiveImage from '../ProgressiveImage/ProgressiveImage';
import './AspectRatioImage.less';

const AspectRatioImage = ({url, title, className, linkComponent}) => {
    const insides = (
        <div className="AspectRatioImage__figure-perspective-wrapper">
            <div className="AspectRatioImage__figure image-hover-element">
                <div className="AspectRatioImage__image">
                    <ProgressiveImage src={url} alt={title} fit="fill" />
                </div>
            </div>
        </div>
    );

    return (
        <div className={classNames('AspectRatioImage', className)}>
            {linkComponent ? linkComponent(insides) : insides}
        </div>
    );
};

AspectRatioImage.propTypes = {
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    className: PropTypes.string,
    linkComponent: PropTypes.func,
};

export default AspectRatioImage;
